export default {
  privat: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbSolutions: 'الحلول',
    breadcrumbCurrent: 'المنزل والملكية',
    hero: {
      eyebrow: 'العملاء الأفراد',
      title: 'منزلك في ناظريك – مخطط جيدًا ومثبّت بذوق',
      lead: 'سواء كان منزلًا عائليًا أو شقة تمليك أو عمارة سكنية – نحمي خصوصيتك وممتلكاتك بأنظمة كاميرات مصممة خصيصًا. دون ترويع ودون مراقبة مفرطة.',
    },
    useCases: {
      title: 'حلول لمنزلك',
      lead: 'كل منزل يختلف عن الآخر. ندرس مداخلك وظروف الإضاءة ورغباتك – ونخطط نقاط المراقبة المناسبة.',
      items: {
        '0': { title: 'باب المنزل والمدخل', desc: 'باب المنزل هو أهم نقطة مراقبة. نخطط كاميرا سرية بدقة جيدة – للتعرف على الوجوه ومراقبة الطرود.' },
        '1': { title: 'المدخل والمرآب', desc: 'التعرف على لوحات السيارات ومراقبة المركبات والتحكم في الدخول – بكاميرات خارجية مقاومة ورؤية ليلية.' },
        '2': { title: 'الحديقة والشرفة', desc: 'راقب مداخل الحديقة والشرفات والمداخل الجانبية. كاميرات مقاومة للطقس بزاوية واسعة للرؤية الشاملة.' },
        '3': { title: 'المداخل الجانبية وباب القبو', desc: 'غالبًا ما تُغفل، لكنها نقطة دخول شائعة. كاميرات إضافية تسد الثغرة الأخيرة.' },
        '4': { title: 'العمارات السكنية', desc: 'المدخل والسلالم والمرافق الخارجية – مخططة بمراعاة الخصوصية مع إخفاء المناطق الخاصة واللافتات.' },
        '5': { title: 'الوصول عبر الهاتف', desc: 'عرض مباشر وإعادة تشغيل على هاتفك – سواء كنت في المنزل أو خارجه. نُعدّ كل شيء.' },
      },
    },
    night: {
      eyebrow: 'الرؤية الليلية',
      title: 'أمان لا ينام',
      lead: 'تقع معظم الحوادث في الظلام. مع كاميرات خاصة نهار/ليل تحافظ على الرؤية الشاملة حتى في الليل – بالأبيض والأسود بالأشعة تحت الحمراء أو حتى بالألوان.',
      items: {
        '0': { title: 'رؤية ليلية بالأشعة تحت الحمراء', desc: 'صور حادة حتى في الظلام التام – حتى 30 مترًا حسب الطراز.' },
        '1': { title: 'اللون الليلي', desc: 'صور ملونة ليلًا بدل الأبيض والأسود – بفضل مستشعرات Starlight الحساسة.' },
        '2': { title: 'إضاءة ذكية', desc: 'مصابيح LED بيضاء عند الحركة كردع وفي الوقت نفسه لتسجيلات ملونة.' },
      },
    },
    privacy: {
      eyebrow: 'حماية البيانات',
      title: 'حماية المناطق الخاصة واحترام الحقوق',
      lead: 'في المراقبة الخاصة، لحماية البيانات أهمية خاصة. منذ البداية نحرص على:',
      list: {
        '0': 'عدم تصوير الطرق العامة أو أراضي الجيران',
        '1': 'إخفاء المناطق الخاصة في الكاميرا أو المسجّل',
        '2': 'لافتات إرشادية عند المداخل (موصى بها قانونيًا)',
        '3': 'تخزين محلي – بياناتك تبقى عندك',
        '4': 'حقوق الوصول وإدارة المستخدمين للعمارات',
      },
      note: 'ملاحظة: تعتمد شرعية المراقبة بالفيديو على الحالة الفردية. ننصحك، لكننا لا نغني عن الاستشارة القانونية.',
    },
    cta: {
      title: 'احمِ ما يهمك',
      lead: 'محادثة أولى غير ملزمة تُظهر لك الإمكانيات المتاحة لمنزلك – بشفافية ودون ضغوط.',
      primary: 'احجز موعد استشارة',
      secondary: 'ابدأ مخطط الكاميرات',
    },
  },
};